"use client"

import { useState, useEffect } from "react"
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom"
import styled from "styled-components"
import { AnimatePresence } from "framer-motion"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

// Pages
import Home from "./pages/Home"
import LoginPage from "./pages/LoginPage"
import RegisterPage from "./pages/RegisterPage"
import QueryPage from "./pages/QueryPage"
import HistoryPage from "./pages/HistoryPage"

// Components
import Navbar from "./components/Navbar"
import AnimatedBackground from "./components/AnimatedBackground"

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
`

const ContentContainer = styled.main`
  flex: 1;
  padding: 20px;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding-top: 80px;
  position: relative;
  z-index: 1;
`

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [username, setUsername] = useState("")
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    // Check if user is logged in
    const storedUsername = localStorage.getItem("username")
    if (storedUsername) {
      setIsAuthenticated(true)
      setUsername(storedUsername)
    } else if (location.pathname !== "/login" && location.pathname !== "/register" && location.pathname !== "/") {
      // Redirect to login if not authenticated and trying to access protected routes
      navigate("/login")
    }
  }, [location.pathname, navigate])

  const handleLogin = (username) => {
    setIsAuthenticated(true)
    setUsername(username)
    localStorage.setItem("username", username)
    navigate("/query")
  }

  const handleLogout = () => {
    setIsAuthenticated(false)
    setUsername("")
    localStorage.removeItem("username")
    navigate("/login")
  }

  return (
    <AppContainer>
      <AnimatedBackground />
      <Navbar isAuthenticated={isAuthenticated} username={username} onLogout={handleLogout} />
      <ContentContainer>
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<Home isAuthenticated={isAuthenticated} />} />
            <Route
              path="/login"
              element={isAuthenticated ? <Navigate to="/query" replace /> : <LoginPage onLogin={handleLogin} />}
            />
            <Route path="/register" element={isAuthenticated ? <Navigate to="/query" replace /> : <RegisterPage />} />
            <Route path="/query" element={isAuthenticated ? <QueryPage /> : <Navigate to="/login" replace />} />
            <Route path="/history" element={isAuthenticated ? <HistoryPage /> : <Navigate to="/login" replace />} />
          </Routes>
        </AnimatePresence>
      </ContentContainer>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </AppContainer>
  )
}

export default App